import { DatePipe } from '@angular/common';
import { provideHttpClient } from '@angular/common/http';
import { enableProdMode, importProvidersFrom } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import Lara from '@primeuix/themes/lara';
import { ConfirmationService, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { AppRoutingModule } from './app/app-routing.module';
import { AppComponent } from './app/app.component';
import { CommonComponentsModule } from './app/components/common/common-components.module';
import { loadEnvironmentConfig } from './environments/make-environment';
import { setup } from './main/setup';

(async () => {
  try {
    const appEnvironment = await loadEnvironmentConfig();

    if (appEnvironment.isProd) {
      enableProdMode();
    }

    await setup();
    await bootstrapApplication(AppComponent, {
      providers: [
        providePrimeNG({
          theme: {
            preset: Lara,
            options: {
              darkModeSelector: 'light',
              cssLayer: {
                name: 'primeng',
                order: 'theme, base, primeng',
              },
            },
          },
        }),
        importProvidersFrom(
          AppRoutingModule,
          BrowserAnimationsModule,
          CommonComponentsModule,
        ),
        provideHttpClient(),
        MessageService,
        ConfirmationService,
        DatePipe,
      ],
    });
    // TODO em looping - a verificar
    // if ('serviceWorker' in navigator) {
    //   await navigator.serviceWorker.register('sw-custom.js');
    //   PWA.checkForUpdates();
    // }
  } catch (error) {
    console.error('Angular Main Setup Error', error);
  }
})();
